import { useState } from "react";
import { fetchPatientBills } from "../../utils/patients/fetchPatientsBills";
import { bookAppointment } from "../../utils/patients/bookAppointment";
import { fetchVitals } from "../../utils/patients/fetchVitals";
import { fetchAppointments } from "../../utils/patients/dashboard/fetchAppointment";
import { fetchTransactions } from "../../utils/patients/dashboard/fechTransactions";
import { CancelAppointment } from "../../utils/patients/cancelAppointment";
import { toast } from "sonner";
import { reScheduleAppointment } from "../../utils/patients/reScheduleAppointment";
import useProfileStore from "../../store/patient/profileStore";
import { useAuth } from "../../context/AuthContext";
import useManagePatient from "./useManagePatient";

const useManageDashboardOverview = () => {

  const [loading, setLoading] = useState(false);
  const [vitals, setVitals ] = useState();
  const [appointments, setAppointment] = useState();
  const [transactions, setTransanctions] = useState();
  const [activity, setActivity] = useState()
  const [confirmModal, setConfirmModal] = useState(false)
  const [showDetailsModal, setShowDetailsModal]= useState(false)
  const {profile} = useProfileStore()
  const {findPatient} = useManagePatient()

  const {user} = useAuth()

  // console.log(user,"user")
 

  

  // id = 27503
  const handleFetchVitals = async () => {
    setLoading(true);
    await fetchVitals(user?.id||profile?.id)
    .then((res) => {
        setLoading(false);
        setVitals(res?.data)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null)
      });
  };

  const handleFetAppointments = async () => {
    setLoading(true);
    await fetchAppointments(user?.id||profile?.id)
    .then((res) => {
        setLoading(false);
        setAppointment(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
        localStorage?.setItem("user", null)
      });
  };
  const handleFetchTransactions = async () => {
    setLoading(true);
    await fetchTransactions(user?.id||profile?.id)
    .then((res) => {
        setLoading(false);
        setTransanctions(res?.data?.result)
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        localStorage?.setItem("user", null)
        console.log("error error");
      });
  };

  const handleCancelAppointment = async (data) => {
    setLoading(true);
    await CancelAppointment(data)
    .then((res) => {
        setLoading(false);
        // setTransanctions(res?.data?.result)
        toast.success("Appoinment Cancelled Successfully")
        setConfirmModal(false)
        handleFetAppointments()
        findPatient()
      })
      .catch((err) => {
        setLoading(false);
        window.location.href = "/pages/signin2";
        console.log("error error");
      });
  };
const handleReScheculeAppointment = async (data) => {
    setLoading(true);
    try {
      await reScheduleAppointment(data);
      setLoading(false);
      toast.success("Appointment Schedulled successfully!");
      handleFetAppointments()
      setShowDetailsModal(false)
    } catch (err) {
      setLoading(false);
      toast.error("Failed to schedule appointment.");
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
  };




  return {
    handleFetchVitals,
    vitals,
    loading,
    appointments,
    handleFetAppointments,
    transactions,
    handleFetchTransactions,
    handleCancelAppointment,
    confirmModal,
    setConfirmModal,
    showDetailsModal, 
    setShowDetailsModal,
    handleReScheculeAppointment
  };
};

export default useManageDashboardOverview;